module.exports = __webpack_public_path__ + "img/a90970b.png";